import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const moment = require("moment");
const React = require("react");
import { config } from "../../../config";
import { features } from "../../../features";
import { unique } from "../../../utils/array";
import { Link } from "../../Link";
import { asPrice, formatDatesDetail, pushEventAction } from "../EventUtils";
import { extractSinglesFromOne } from "./EventDetailsUtils";
export const EventMetaCard = (param)=>{
    let { event } = param;
    const eventsConfig = features().events;
    if (eventsConfig == 'off') return /*#__PURE__*/ _jsx(_Fragment, {});
    const { arrowIconId } = config().ui;
    const { noTicketRequired } = eventsConfig.detailPage.copy;
    const cancelled = event.Status != 'published';
    const single = event.Kind !== 'single' ? false : event.Tickets.length == 0 ? 'noTickets' : event.Tickets.length == 1 ? 'oneTicket' : unique(event.Tickets.map((t)=>t.Uri)).length == 1 ? 'singleUri' : 'multipleUris';
    const { date, time } = formatDatesDetail(event);
    const ownLocations = (event.Locations ?? []).filter((l)=>l === null || l === void 0 ? void 0 : l.Name);
    const sourceLocations = ownLocations.length > 0 ? ownLocations : extractSinglesFromOne(event).reduce((acc, e)=>acc.concat(e.Locations ?? []), []);
    const locationNames = Array.from(new Set(sourceLocations.map((l)=>l === null || l === void 0 ? void 0 : l.Name).filter((n)=>!!n)));
    const [locationName, addressAttributes] = locationNames.length == 1 ? [
        locationNames[0],
        {}
    ] : locationNames.length > 1 ? [
        "Meerdere",
        {
            title: locationNames.slice().sort().join('\n')
        }
    ] : [
        null,
        {}
    ];
    // Skip price for multi-date events, ticketless events, and a lone free ticket
    const displayPrice = single == 'oneTicket' ? event.Tickets[0].Cost > 0 : single == 'singleUri' || single == 'multipleUris';
    // wrapper keeps :first/:last-child styling working next to the sr-text sibling
    const rows = /*#__PURE__*/ _jsxs("div", {
        className: "event-meta__rows",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "event-meta__row",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "event-meta__label",
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                className: "event-meta__icon",
                                width: "20",
                                height: "22",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--calendar"
                                })
                            }),
                            "Datum"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("time", {
                        className: "event-meta__value",
                        dateTime: moment(event.Start).format('YYYY-MM-DD'),
                        children: date
                    })
                ]
            }),
            single && time && /*#__PURE__*/ _jsxs("div", {
                className: "event-meta__row",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "event-meta__label",
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                className: "event-meta__icon",
                                width: "20",
                                height: "20",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--clock"
                                })
                            }),
                            "Tijd"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "event-meta__value",
                        children: time
                    })
                ]
            }),
            locationName && /*#__PURE__*/ _jsxs("div", {
                className: "event-meta__row",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "event-meta__label",
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                className: "event-meta__icon",
                                width: "15",
                                height: "18",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--location"
                                })
                            }),
                            "Locatie"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("address", {
                        className: "event-meta__value",
                        ...addressAttributes,
                        children: locationName
                    })
                ]
            }),
            displayPrice && /*#__PURE__*/ _jsxs("div", {
                className: "event-meta__row",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "event-meta__label",
                        children: [
                            /*#__PURE__*/ _jsx("svg", {
                                className: "event-meta__icon",
                                width: "16",
                                height: "16",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: "#icon--price"
                                })
                            }),
                            "Prijs"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: "event-meta__value",
                        children: [
                            single == 'oneTicket' && event.Tickets[0].Cost > 0 && // A single ticket requires no description
                            /*#__PURE__*/ _jsx("span", {
                                className: "event-meta__price",
                                children: /*#__PURE__*/ _jsx(TicketElement, {
                                    ticket: {
                                        ...event.Tickets[0],
                                        Description: ''
                                    }
                                })
                            }),
                            single == 'singleUri' && event.Tickets.map((ticket, i)=>/*#__PURE__*/ _jsx("span", {
                                    className: "event-meta__price",
                                    children: /*#__PURE__*/ _jsx(TicketElement, {
                                        ticket: ticket,
                                        linkUri: false
                                    }, `ticket-link-${i}`)
                                })),
                            single == 'multipleUris' && event.Tickets.map((ticket, i)=>/*#__PURE__*/ _jsx("span", {
                                    className: "event-meta__price",
                                    children: /*#__PURE__*/ _jsx(TicketElement, {
                                        ticket: ticket,
                                        linkUri: true
                                    }, `ticket-link-${i}`)
                                }))
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "event-meta",
        children: cancelled ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "sr-text",
                    children: "Deze activiteit is geannuleerd. Het was gepland op: "
                }),
                /*#__PURE__*/ _jsx("del", {
                    className: "event-meta__cancelled",
                    children: rows
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "event__status",
                    "aria-hidden": "true",
                    children: "Deze activiteit is geannuleerd."
                })
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "sr-text",
                    children: "Waar en wanneer: "
                }),
                rows,
                (single == 'oneTicket' || single == 'singleUri') && /*#__PURE__*/ _jsx("div", {
                    className: `event__tickets event-meta__tickets`,
                    children: /*#__PURE__*/ _jsxs(Link, {
                        className: "button button--primary button--event-ticket event__ticket",
                        url: event.Tickets[0].Uri,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "ticket__description",
                                children: "Meld je aan"
                            }),
                            /*#__PURE__*/ _jsx("svg", {
                                className: "event__ticket-icon",
                                width: "16",
                                height: "16",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ _jsx("use", {
                                    xlinkHref: arrowIconId
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const TicketElement = (param)=>{
    let { ticket, linkUri = false } = param;
    if (!ticket.Cost && !ticket.Description) return /*#__PURE__*/ _jsx(_Fragment, {});
    const push = pushEventAction();
    const text = ticket.Cost && !ticket.Description ? asPrice(ticket.Cost) : !ticket.Cost && ticket.Description ? ticket.Description : `${asPrice(ticket.Cost)} ${ticket.Description.toLocaleLowerCase()}`;
    return linkUri ? /*#__PURE__*/ _jsx(Link, {
        url: ticket.Uri,
        handle: ()=>{
            push("ticket-click", text);
        },
        children: text
    }) : /*#__PURE__*/ _jsx("span", {
        className: "event-meta__price",
        children: text
    });
};
